import { Box, Flex } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import ManagePromptTemplates from "src/components/managePromptTemplates";

export const ManagePromptTemplatesRoute = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (window.location.hash === "#/managePromptTemplates")
            navigate({ to: "/managePromptTemplates" });
    }, [navigate]);

    return (
        <Flex p="xl" direction="column" gap="md">
            <Box>
                <ManagePromptTemplates />
            </Box>
        </Flex>
    );
};
